export const DEFAULT_OFFER_LISTING_PAGE = 1;

export const DEFAULT_FETCH_OFFER_LISTING_PAGE_SIZE = 10;
